import { AbstractDownloadableService } from '../abstract-downloadable.service';
import { AbstractReport } from '../../models/reports/abstract-report.model';

/**
 * @class AbstractReportAdminPmsApiService
 * @abstract
 * @extends {AbstractDownloadableService<Feedback>}
 */
export class AbstractReportAdminPmsApiService extends AbstractDownloadableService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/report';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {AbstractReport}
     * @protected
     */
    newModel(attributes, ...params) {

        return new AbstractReport(attributes);
    }

    /**
     * @param {Object=} params
     * @returns {Promise.<PaginationCollection<AbstractReport>>}
     */
    get(params = {}) {

        const url = this.url();

        return this.http
            .post(url, params, {
                headers: this.authHeaders,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    exportPdf(params = {}) {

        const url = this.url() + '/export-pdf';

        return this.download(url, params, 'Report.pdf');
    }

    exportCsv(params = {}) {

        const url = this.url() + '/export-csv';

        return this.download(url, params, 'Report.csv');
    }

    exportExcel(params = {}) {

        const url = this.url() + '/export-excel';

        return this.download(url, params, 'Report.xlsx');
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/abstract-report-admin.service.js